import {JobEventApiDto, JobQuoteAcceptedEventDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import Attachment from "../../attachment/Attachment";
import JobEvent, {JobEventTypeEnum} from "./JobEvent";
import moment = require("moment");
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";

export default class JobQuoteAcceptedEvent extends JobEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} jobId job id.
	 * @param {JobEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber lead reference number.
	 * @param data job quote files attached files event data
	 */
	constructor(public readonly id: string,
		public readonly jobId: string,
		public readonly type: JobEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: JobQuoteAcceptedEventData) {
		super(id, jobId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: JobEventApiDto): JobQuoteAcceptedEvent {
		const data = JobQuoteAcceptedEventData.fromJson(json.data as JobQuoteAcceptedEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new JobQuoteAcceptedEvent(json.id,
			json.jobId,
			JobEventTypeEnum.QuoteAccepted,
			entity,
			moment(json.createdAt),
			json.referenceNumber,
			data);
	}

	getIcon() {
		return Icon.File;
	}

	getIconColor(): IconColor {
		return IconColor.Burgundy;
	}

	getAttachments(): Attachment[] {
		return this.data.attachments;
	}

	getActivityType() {
		return `Quote ${this.referenceNumber}${this.data.versionNumber > 1 ? ` v${this.data.versionNumber}` : ""}`
	}

	getActivityMessage(): string {
		return "Quote accepted";
	}
}

export class JobQuoteAcceptedEventData {
	constructor(public readonly quoteId: string,
		public readonly attachments: Attachment[],
		public readonly versionNumber: number) {}

	public static fromJson(json: JobQuoteAcceptedEventDataApiDto): JobQuoteAcceptedEventData {
		return new JobQuoteAcceptedEventData(json.quoteId, json.attachments.map(Attachment.fromJson), json.versionNumber);
	}
}
